import GradeFeeEdit from "@/controllers/grade_fee/grade-fee-edit.js";
import {
    required,
    numeric
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    extends: GradeFeeEdit,
    data() {
        return {
            academic_year: 0,
            campus_grade_id: 0,
            academicYearArr: [],
            gradeArr: [],
        };
    },

    validations: {
        academic_year: {
            required,
        },
        campus_grade_id: {
            required,
        },
        gradeFeeData: {
            annual_fee: {
                numeric,
            },
            monthly_fee: {
                numeric,
            },
            termly_fee: {
                numeric,
            },
            atLeastOneFee: {
                validator() {
                    return this.atLeastOneFee();
                }
            }
        },
    },

    methods: {
        getCampusGradeName() {
            this.getAcademicYears();
        },

        getAcademicYears() {
            axios.get("period/periodList")
                .then((res) => {
                    const defaultOption = [{ id: 0, text: "Select Academic Year" }];
                    this.academicYearArr = defaultOption.concat(res.data.data || []);
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.academicYearArr = [{ id: 0, text: "Select Academic Year" }];
                });
        },

        getGradeList(yearId, selectedCampusGradeId = 0, showLoading = false) {
            const defaultOption = [{ id: 0, text: "Select Grade" }];
            this.gradeArr = defaultOption;

            if (!yearId || Number(yearId) === 0) {
                this.campus_grade_id = selectedCampusGradeId || 0;
                if (showLoading) {
                    this.isLoading = false;
                }
                return;
            }

            if (showLoading) {
                this.isLoading = true;
            }
            axios.get("campusGrade/list-by-acdYear", {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                    acd_year_id: yearId,
                    get_grade: true,
                }
            }).then((res) => {
                const rows = Array.isArray(res.data) ? res.data : [];
                this.gradeArr = defaultOption.concat(rows.map((grade) => ({
                    id: grade.campus_grade_id,
                    text: grade.grade_name
                })));
                this.campus_grade_id = selectedCampusGradeId || 0;
            }).catch((error) => {
                if (error.response && error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
            }).finally(() => {
                if (showLoading) {
                    this.isLoading = false;
                }
            });
        },

        atLeastOneFee() {
            return (
                !!this.gradeFeeData.annual_fee ||
                !!this.gradeFeeData.monthly_fee ||
                !!this.gradeFeeData.termly_fee
            )
        },

        changeEvent(val, fieldName) {
            this.$set(this, fieldName, val);

            if (fieldName === 'academic_year') {
                this.submitted = false;
                this.campus_grade_id = 0;
                this.getGradeList(val);
            }
        },

        confirmUpdate() {
            if (this.disabled) return;
            this.submitted = true;
            if (
                this.$v.$invalid ||
                this.academic_year == '' ||
                this.academic_year == 0 ||
                this.campus_grade_id == '' ||
                this.campus_grade_id == 0
            ) {
                return;
            }
            this.update();
        },

        getGradeFeeEdit() {
            axios
                .get("/gradeFee/detail/" + this.$route.params.id, {
                    params: {
                        campus_id: this.$store.state.user.campus_id,
                        is_edit: true,
                    },
                })
                .then((response) => {
                    this.gradeFeeData = response.data;
                    this.academic_year = Number(this.gradeFeeData.acd_year_id) || 0;
                    this.getGradeList(this.academic_year, Number(this.gradeFeeData.campus_grade_id) || 0, true);
                })
                .catch((error) => {
                    if (error.response && error.response.status == 404) {
                        this.gradeFeeData = {};
                    }
                    if (error.response && error.response.status == 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                    this.isLoading = false;
                    console.log("Class Detail API Error", error);
                });
        },

        update() {
            this.disabled = true;
            var id = this.$route.params.id;
            var request = {
                campus_grade_id: this.campus_grade_id,
                annual_fee: this.gradeFeeData.annual_fee,
                monthly_fee: this.gradeFeeData.monthly_fee,
                termly_fee: this.gradeFeeData.termly_fee,
            };
            axios.post("/gradeFee/update/" + id, request, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.data.status == 200) {
                        this.$notification.success("Grade Fee Updated Successfully", {
                            timer: 3,
                            position: "bottomCenter",
                        });
                        this.$router.push({
                            name: "gradeFeeList",
                        });
                    } else {
                        this.disabled = false;
                        this.$notification.error(response.data.message, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                    if (error.response.status == 422) {
                        this.disabled = false;
                        this.$notification.error(error.response.data.message, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    this.disabled = false;
                    this.isLoading = false;
                    console.log("Class Edit API Error", error.errors);
                });
        },

        selectEvent({ id }, fieldName) {
            id == 'Select' ? this.$set(this, fieldName, '') : this.$set(this, fieldName, id);
        },
    },

    mounted() {
        this.isLoading = true;
    },
};
